export function fromForm(formName: string, model: any = {}): any {
  return Object.assign({}, model, { formName });
}

export function isForm(formName: string, payload: any = {}): boolean {
  return payload.formName === formName;
}
